import { useMsal } from "@azure/msal-react";
import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";

type UserProcessingProps = {
  show: boolean;
  handleClose: () => void;
};
export default function FindAccountNumberModal({
  show,
  handleClose,
}: UserProcessingProps) {
  return (
    <Modal size="lg" show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Find my account number</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Please see sample screenshots below to find your Lab account number.
        </p>
        <div className="flex mt-4 flex-col gap-4">
          <div>
            <img
              src="/images/lab_account-number1.png"
              alt="Lab Account number"
              className="max-w-full"
            />
          </div>
          <div>
            <img
              src="/images/lab_account-number2.png"
              alt="Lab Account number"
              className="max-w-full"
            />
          </div>
          <div>
            <img
              src="/images/lab_account-number3.png"
              alt="Lab Account number"
              className="max-w-full"
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="flex justify-end w-full">
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
